import { Store } from '@ngrx/store';
import { LiteralsState } from '../../reducers/literals.reducer';
import { FacadeService } from '../facade.service';
import { Injectable } from '@angular/core';
import * as selectors from '../../selectors/literals/campaign-search.literals.selector';

@Injectable({
  providedIn: 'root',
})
export class CampaignSearchLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  campaignId$ = this.storeSelect(selectors.getCampaignId);
  campaignStatus$ = this.storeSelect(selectors.getCampaignStatus);
  campaignName$ = this.storeSelect(selectors.getCampaignName);
  campaignSchema$ = this.storeSelect(selectors.getCampaignSchema);
  campaignCategory$ = this.storeSelect(selectors.getCampaignCategory);
  campaignCountry$ = this.storeSelect(selectors.getCampaignCountry);
  campaignChannel$ = this.storeSelect(selectors.getCampaignChannel);
  campaignTarget$ = this.storeSelect(selectors.getCampaignTarget);
  campaignDescription$ = this.storeSelect(selectors.getCampaignDescription);
  campaignActiveFrom$ = this.storeSelect(selectors.getCampaignActiveFrom);
  campaignActiveUntil$ = this.storeSelect(selectors.getCampaignActiveUntil);

  // OBSERVABLE'S VALUES
  get campaignId() {
    return this.storeSnapshot(this.campaignId$);
  }
  get campaignStatus() {
    return this.storeSnapshot(this.campaignStatus$);
  }
  get campaignName() {
    return this.storeSnapshot(this.campaignName$);
  }
  get campaignSchema() {
    return this.storeSnapshot(this.campaignSchema$);
  }
  get campaignCategory() {
    return this.storeSnapshot(this.campaignCategory$);
  }
  get campaignCountry() {
    return this.storeSnapshot(this.campaignCountry$);
  }
  get campaignChannel() {
    return this.storeSnapshot(this.campaignChannel$);
  }
  get campaignTarget() {
    return this.storeSnapshot(this.campaignTarget$);
  }
  get campaignDescription() {
    return this.storeSnapshot(this.campaignDescription$);
  }
  get campaignActiveFrom() {
    return this.storeSnapshot(this.campaignActiveFrom$);
  }
  get campaignActiveUntil() {
    return this.storeSnapshot(this.campaignActiveUntil$);
  }
}
